import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_42.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Head from "next/head";
import BlockData from "../../../central-doctraine-json/chapter42.json";
import Common_html from "./Common_html";

export default function Chapter_42() {

    const router = useRouter()
    const location = useRouter();
    const { pathname } = location;

    // const corosalref = useRef();

    // useEffect(() => {
    //   if (corosalref.current) {
    //     corosalref.current.scrollIntoView({
    //       behavior: "smooth",
    //       block: "nearest",
    //       inline: "start",
    //     });
    //   }
    //   console.log("CurrentImageComponent", corosalref.current);
    // }, [corosalref.current]);
    return (
        <>
            <Head>
                <title>THE BIG BANG UNIVERSE | School of Our Divine Infinite Being</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                ></meta>
                <meta
                    name="keywords"
                    content="Divine Infinite Being, Central Doctrine, Chapter-XLIII"
                ></meta>
                <meta
                    property="og:title"
                    content="THE BIG BANG UNIVERSE | School of Our Divine Infinite Being"
                ></meta>
                <meta property="og:type" content="website"></meta>
                <meta
                    property="og:image"
                    content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
                ></meta>
                <meta property="og:image:alt" content="Artistic representation of the Big Bang, illustrating the birth of the universe and its connection to the Divine Infinite Being, highlighting the interplay between cosmic creation and spiritual origins."></meta>
                <meta
                    property="og:description"
                    content="Delve into the Divine Infinite Being's perspective on the Big Bang, exploring the universe's creation as an expression of divine will. Discover the spiritual significance behind the cosmos' origin and its connection to the eternal essence of existence."
                ></meta>

                <meta property="og:image:width" content="1200"></meta>
                <meta property="og:image:height" content="627"></meta>
                <meta
                    property="og:url"
                    content="https://www.divineinfinitebeing.com/central-doctrine?chapter=42"
                ></meta>

                <meta name="twitter:card" content="summary_large_image"></meta>
                <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
                <meta property="twitter:image:alt" content="Artistic representation of the Big Bang, illustrating the birth of the universe and its connection to the Divine Infinite Being, highlighting the interplay between cosmic creation and spiritual origins."></meta>
                <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=42"></meta>
                <meta name="twitter:title" content="THE BIG BANG UNIVERSE | School of Our Divine Infinite Being"></meta>
                <meta name="twitter:description" content="Delve into the Divine Infinite Being's perspective on the Big Bang, exploring the universe's creation as an expression of divine will. Discover the spiritual significance behind the cosmos' origin and its connection to the eternal essence of existence."></meta>
                <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=42" />
            </Head>


            <Common_html BlockData={BlockData} />
        </>
    );
}
